export default __webpack_public_path__ + "static/media/notfound.6a56f75a.svg";